<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-DuoLeiXingKaCaoWeiXuanZhong`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.36369 6.71766L11.3304 2.61768C11.6133 2.47209 11.9486 2.4698 12.2334 2.61151L20.3872 6.66798C20.727 6.83702 20.9418 7.18381 20.9418 7.56331V15.7345C20.9418 16.0939 20.7489 16.4256 20.4366 16.6035L12.3083 21.2317C11.9999 21.4072 11.6216 21.4063 11.3142 21.2291L3.32198 16.6233C3.01219 16.4448 2.82129 16.1145 2.82129 15.7569V7.60682C2.82129 7.23224 3.03063 6.88907 3.36369 6.71766ZM5.17826 7.431L11.7782 4.06779L14.1904 5.25481L7.81342 8.7683C7.79711 8.77729 7.78127 8.78679 7.76591 8.79678L5.17826 7.431ZM4.34405 8.68359L4.34392 15.4589L11.1017 19.3326V12.2503L4.34405 8.68359ZM12.5988 19.3157L19.4786 15.455L19.4262 8.70397L12.5988 12.3187V19.3157ZM18.6221 7.43568L15.7503 6.02248C15.6875 6.10982 15.6047 6.18491 15.5042 6.2403L9.34832 9.63198L11.915 10.9867L18.6221 7.43568Z"/></svg>
</template>
<script>

export default {
  name: 'IconDuoLeiXingKaCaoWeiXuanZhong',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
